
import * as Sentry from "@sentry/react";
import { createBrowserRouter } from "react-router-dom";

const SENTRY_DSN = "https://fd0aa6a6fdc4576a403ec686613643bc@o4509403419705344.ingest.us.sentry.io/4509403455750144";

export function initSentry() {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with an error will be recorded
    
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    
    beforeSend(event, hint) {
      // Filter out non-critical errors in development
      if (import.meta.env.DEV) {
        console.log('Sentry event:', event);
      }
      return event;
    },
  });
}

export function setUserContext(user: { id: string; email?: string; name?: string }) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
  });
}

export function addBreadcrumb(message: string, category: string, level: 'info' | 'warning' | 'error' = 'info') {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    timestamp: Date.now() / 1000,
  });
}

export function captureException(error: Error, context?: Record<string, any>) {
  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext("additional_info", context);
    }
    Sentry.captureException(error);
  });
}

export function captureMessage(message: string, level: 'info' | 'warning' | 'error' = 'info') {
  Sentry.captureMessage(message, level);
}
